<template>
  <dialog class="mb-modal" ref="modal">
    <div class="mb-modal-content" :style="contentStyle">
      <slot name="title">
        <div class="mb-modal-title">
          <span>{{ title }}</span>
          <img src="/images/trumpet-white.svg" id="mb-modal-trumpet" class="d-none d-sm-inline-block" />
          <button
            type="button"
            class="btn-close btn-close-white mb-modal-close"
            aria-label="Close"
            @click="close()"
          ></button>
        </div>
      </slot>
      <slot></slot>
    </div>
  </dialog>
</template>

<style scoped>
.mb-modal-close {
  text-shadow: none;
  opacity: 0.9;
  float: right;
}

.mb-modal {
  overflow: visible;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 500vh;
  border: none;
  z-index: 500;
  background: none;
}

@media (max-width: 576px) {
  .mb-modal {
    right: 0;
    margin: 0;
    max-width: 100%;
    height: 100%;
  }
}
.mb-modal::backdrop {
  opacity: 0.3;
  background-color: #000;
}

.mb-modal .mb-modal-content {
  overflow: visible;
  margin: auto;
  vertical-align: middle;
  width: auto;
  max-width: 800px;
  height: max-content;
  background: #fff;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
  border-radius: 5px;
}

.mb-modal-title {
  background-color: #ff6a00;
  color: #eeeeee;
  font-size: 1.25em;
  padding: 10px;
}

#mb-modal-trumpet {
  height: 40px;
  margin-left: 20px;
}

/* Open state of the dialog  */
.mb-modal:open {
  opacity: 1;
}

.mb-modal[open] {
  opacity: 1;
}

/* Closed state of the dialog   */
.mb-modal {
  opacity: 0;
  transition: opacity 0.2s ease-out, overlay 0.2s ease-out allow-discrete, display 0.2s ease-out allow-discrete;
  /* Equivalent to
  transition: all 0.7s allow-discrete; */
}

/* Before open state  */
/* Needs to be after the previous dialog:open rule to take effect,
    as the specificity is the same */
@starting-style {
  .mb-modal:open {
    opacity: 0;
  }
}

/* Transition the :backdrop when the dialog modal is promoted to the top layer */
.mb-modal::backdrop {
  transition: display 0.7s allow-discrete, overlay 0.7s allow-discrete, background-color 0.7s;
  /* Equivalent to
  transition: all 0.7s allow-discrete; */
}

/* This starting-style rule cannot be nested inside the above selector
because the nesting selector cannot represent pseudo-elements. */

@starting-style {
  .mb-modal:open::backdrop {
    background-color: transparent;
  }
}
</style>
<script>
export default {
  props: ["title", "size"],
  methods: {
    show() {
      this.$refs.modal.showModal()
    },
    close() {
      this.$emit("on-close")
      this.$refs.modal.close()
    },
  },
  computed: {
    contentStyle() {
      if ( this.size == "small" ) {
        return { "max-width": "500px" }
      } else {
        return {}
      }
    }
  }
}
</script>
